// Grapheme-level so a compound emoji counts as one cluster. Mirrors the server name rule
// (OrganisationName.cs, EIT-13 AC4) exactly: rejects control chars, the zero-width
// space/joiner code points and the bidi marks/overrides as a homograph/spoof defence (the
// name is shown in the staff console + logs). RTL scripts, ZWNJ (U+200C) and ZWJ (U+200D)
// are allowed — ZWNJ is orthographically required by Persian/Kurdish compounds, and the
// server accepts both.

// Disallowed invisible/spoofing code points, by code point (avoids literal invisibles):
//   zero-width: ZWSP U+200B, BOM U+FEFF, WORD JOINER U+2060.
//   bidi marks/overrides: LRM U+200E, RLM U+200F, U+202A–202E.
function hasSpoofingChar(text: string): boolean {
  for (const ch of text) {
    const cp = ch.codePointAt(0) ?? 0;
    if (cp === 0x200b || cp === 0x2060 || cp === 0xfeff) return true;
    if (cp === 0x200e || cp === 0x200f) return true;
    if (cp >= 0x202a && cp <= 0x202e) return true;
  }
  return false;
}

export function validateOrganisationName(name: string): 'invalid_name' | null {
  const trimmed = name.trim();
  if (/\p{Cc}/u.test(trimmed)) return 'invalid_name'; // control characters (server precedence 1)
  if (hasSpoofingChar(trimmed)) return 'invalid_name';
  const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
  const clusters = [...segmenter.segment(trimmed)].length;
  if (clusters < 2 || clusters > 80) return 'invalid_name';
  return null;
}
